import { Divider, List as AntdList, Row, Space } from 'antd'
import AvailabilityTag from 'app/components/Core/CategorySegment/Tag/Availability'
import KListItem from 'app/components/Modules/List/KListItem'
import KCol from 'app/components/UI-Elements/Layout/KCol'
import testIds from 'test_ids.json'

import { CollectionProps } from '../convention'
import LineItemImage from '../LineItem/Image'

type Props = {
  onItemClick?: (attachment: IAttachment) => void
}

const List: React.FC<CollectionProps<IAttachment, Props>> = ({
  collection = [],
  props: { onItemClick } = {}
}) => {
  const handleClick = (item: IAttachment) => {
    if (!item.hasAdded) {
      onItemClick?.(item)
    }
  }

  return (
    <Row gutter={[0, 12]}>
      <KCol span={24}>
        <Divider className="my-0" />
        <AntdList
          itemLayout="horizontal"
          dataSource={collection}
          renderItem={(item) => (
            <KListItem
              data-testid={testIds.checkout.machines.packages.attachment}
              className={item.hasAdded ? 'disabled' : 'pointer'}
              onClick={() => handleClick(item)}
              verticalAlign
              avatar={
                <LineItemImage
                  member={{ name: item.name, image_url: item?.categorySegment?.image_url }}
                />
              }
              title={item.name}
              extra={
                <Space align="center">
                  <AvailabilityTag member={item?.categorySegment} />
                </Space>
              }
            />
          )}
        />
        <Divider className="my-0" />
      </KCol>
    </Row>
  )
}

export default List
